import * as CompetitionApi from '../../api/competition'
import axios from 'axios'
import router from '../../router'
import selectedCompetitionStore from '../selectedCompetition/selectedCompetitionStore'
import { competitionStatusFilterTypes } from '../../constants/competitonStatusFilterTypes'
import { competitionStatus } from '../../constants/competitionStatus'
import { competitionTypes } from '../../constants/competitionTypes'

let CancelToken = axios.CancelToken
let cancelToken = null
let cancel

function convertServerRequest(filters) {
  const status = convertStatus(filters.status)
  const type = []
  filters.showApplication && type.push(competitionTypes.APPLICATION)
  filters.showCredit && type.push(competitionTypes.CREDIT)
  filters.showCapital && type.push(competitionTypes.CAPITAL_PRODUCT)
  filters.showGuarantee && type.push(competitionTypes.GUARANTEE)
  return {
    name: filters.name,
    status,
    type
  }
}

function convertStatus(status) {
  switch (status) {
    case competitionStatusFilterTypes.SHOW_ALL:
      return [
        competitionStatus.ACTIVE,
        competitionStatus.APPROVED,
        competitionStatus.DRAFT,
        competitionStatus.INACTIVE,
        competitionStatus.UNDER_APPROVAL
      ]
    case competitionStatusFilterTypes.IN_PROGRESS:
      return [competitionStatus.DRAFT]
    case competitionStatusFilterTypes.UNDER_APPROVAL:
      return [competitionStatus.UNDER_APPROVAL]
    case competitionStatusFilterTypes.APPROVED:
      return [competitionStatus.APPROVED]
    case competitionStatus.ACTIVE:
      return [competitionStatus.ACTIVE]
    case competitionStatusFilterTypes.INACTIVE:
      return [competitionStatus.INACTIVE]
    default:
      throw Error('Hibás lekérdezés')
  }
}

function updateMultipleCompetitionFilter({ commit, dispatch, state }, payload) {
  commit('setCompetitionCurrentPage', 1)
  Object.keys(payload).forEach(key => {
    commit('setCompetitionFilter', { key, value: payload[key] })
  })
  const filters = JSON.parse(JSON.stringify(state.filters))
  router.replace({ query: filters })
  dispatch('getCompetitionList')
}

function updateCompetitionFilter({ commit, dispatch, state }, payload) {
  commit('setCompetitionCurrentPage', 1)
  commit('setCompetitionFilter', payload)
  const filters = JSON.parse(JSON.stringify(state.filters))
  router.replace({ query: filters })
  dispatch('getCompetitionList')
}

function changeCompetitionPage({ commit, dispatch }, payload) {
  commit('setCompetitionCurrentPage', payload)
  dispatch('getCompetitionList')
}

async function getCompetitionList({ state, commit }) {
  if (cancelToken !== null) {
    cancel('Request cancelled')
  }
  cancelToken = new CancelToken(c => {
    cancel = c
  })
  try {
    const data = await CompetitionApi.listCompetitions(
      { ...convertServerRequest(state.filters), page: state.currentPage - 1 },
      cancelToken
    )
    cancelToken = null
    commit('updateCompetitionList', data)
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e
    }
  }
}

function updateCompetitionList(state, { data, totalCount }) {
  state.competitions = data
  state.totalCount = totalCount
  state.loading = false
}

function setCompetitionFilter(state, payload) {
  state.filters[payload.key] = payload.value
}

function setCompetitionCurrentPage(state, currentPage) {
  state.currentPage = currentPage
}

function setAllFiltersFromRouteQuery(state) {
  const query = JSON.parse(JSON.stringify(router.history.current.query))
  const filters = { ...state.filters, ...query }
  state.filters = filters
}

function setInitialState(state) {
  Object.assign(state, initialState)
}

const initialState = {
  competitions: [],
  totalCount: 0,
  currentPage: 1,
  loading: true,
  isModified: false,
  filters: {
    name: '',
    status: competitionStatusFilterTypes.SHOW_ALL,
    showApplication: false,
    showCredit: false,
    showGuarantee: false,
    showCapital: false,
    qualificationStart: undefined,
    qualificationEnd: undefined
  }
}

function isModified(state) {
  return state.isModified
}

function setIsModified(state) {
  state.isModified = true
}

function clearIsModified(state) {
  state.isModified = false
}

const competitionStore = {
  modules: {
    selectedCompetitionStore
  },
  state: initialState,
  actions: { getCompetitionList, updateCompetitionFilter, changeCompetitionPage, updateMultipleCompetitionFilter },
  getters: {
    isModified,
    competitionList: state => state.competitions,
    competitionListTotalCount: state => state.totalCount,
    competitionFilters: state => state.filters,
    competitionNameFilter: state => state.filters.name,
    competitionStatusFilter: state => state.filters.status,
    competitionsLoading: state => state.loading,
    competitionCurrentPage: state => state.currentPage
  },
  mutations: {
    clearIsModified,
    setIsModified,
    updateCompetitionList,
    setCompetitionFilter,
    setInitialState,
    setCompetitionCurrentPage,
    setAllFiltersFromRouteQuery
  }
}

export default competitionStore
